import React from 'react';
import styles from './steps.module.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/** Prod's Key/Value table — bordered header row, placeholder row when
 * empty (gray "Key"/"Value"), matching the API modal's Query Params pane.
 * Cells take any node so the variables modal can render its {x} glyph and
 * copyable values in the same frame. */
export function KeyValueTable(_ref) {
  var rows = _ref.rows,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$keyCellClassName = _ref.keyCellClassName,
    keyCellClassName = _ref$keyCellClassName === void 0 ? styles.apiKvKey : _ref$keyCellClassName,
    _ref$valueCellClassNa = _ref.valueCellClassName,
    valueCellClassName = _ref$valueCellClassNa === void 0 ? styles.apiKvVal : _ref$valueCellClassNa;
  return /*#__PURE__*/_jsxs("table", {
    className: "".concat(styles.apiKvTable, " ").concat(className),
    children: [/*#__PURE__*/_jsx("thead", {
      children: /*#__PURE__*/_jsxs("tr", {
        children: [/*#__PURE__*/_jsx("th", {
          className: styles.apiKvTh,
          children: "Key"
        }), /*#__PURE__*/_jsx("th", {
          className: styles.apiKvTh,
          children: "Value"
        })]
      })
    }), /*#__PURE__*/_jsx("tbody", {
      children: rows.length === 0 ? /*#__PURE__*/_jsxs("tr", {
        children: [/*#__PURE__*/_jsx("td", {
          className: styles.apiKvPlaceholder,
          children: "Key"
        }), /*#__PURE__*/_jsx("td", {
          className: styles.apiKvPlaceholder,
          children: "Value"
        })]
      }) : rows.map(function (row) {
        return /*#__PURE__*/_jsxs("tr", {
          children: [/*#__PURE__*/_jsx("td", {
            className: keyCellClassName,
            children: row.name
          }), /*#__PURE__*/_jsx("td", {
            className: valueCellClassName,
            children: row.value
          })]
        }, row.id);
      })
    })]
  });
}